import { Form, useFormApi } from "informedv4";
import * as React from 'react';
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { TextArea } from '../../forms/informedv4/TextAreaV4';
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import Modal from "../../misc/components/modal";
import { AuditModalBody } from "../../auditmodal/components/AuditModalBody";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";

export interface StudyInformationModalProps {
    studyId: string;
    initialValue: string;
    onClose: () => void;
}

export const StudyInformationModal = ({ studyId, initialValue, onClose }: StudyInformationModalProps) => {
    const [confirmed, setConfirmed] = React.useState<boolean>(false);
    const [studyInformation, setStudyInformation] = React.useState<string>("");
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [errorAlert, setErrorAlert] = React.useState<string>(null);

    const Client = useWebPortalApiClient();

    const handleConfirm = (updatedMessage : string) => {
        setConfirmed(true);
        setStudyInformation(updatedMessage);
    }

    const handleAuditSubmit = async (annotation: string) => {
        setConfirmed(false);
        setSubmitting(true);
        setErrorAlert(null);
        onClose();

        try {
            await Client.client.patchStudy({
                welcomeMessage: studyInformation ?? null,
            }, studyId, annotation);
        }
        catch (error) {
            console.error(error);
            setErrorAlert(error);
        }
        finally {
            setSubmitting(false);
        }
    }

    return (
        <Modal show={true} header="Edit Study Information" closeModalHandler={onClose}>
            <Alert show={errorAlert !== null} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            {confirmed ? <AuditModalBody isSubmitting={false} onClose={onClose} onSubmit={(values) => handleAuditSubmit(values.Annotation)} /> :
                <Form initialValues={{ WelcomeMessage: initialValue ? initialValue : "" }} noValidate >
                    <StudyInformationModalBody onClose={onClose} onSubmit={(updatedMessage) => handleConfirm(updatedMessage)} />
                </Form>
            }
        </Modal>
    )
}

export interface StudyInformationModalBodyProps {
    onClose: () => void;
    onSubmit: (updatedMessage: string) => void;
}

export const StudyInformationModalBody = ({ onClose, onSubmit }: StudyInformationModalBodyProps) => {

    const formApi = useFormApi();

    return (
        <>
            <ErrorBoundary>
                <div className="modal-body">
                    <div className="form-group">
                        <p>
                            <u>Basic</u> markdown syntax is supported for styling messages.
                            Refer to the <a href="https://www.markdownguide.org/cheat-sheet/" target="_blank">Markdown Cheat Sheet</a> for guidance.
                        </p>
                        <div>
                            <TextArea
                                className="form-group"
                                id="WelcomeMessage"
                                field="WelcomeMessage"
                                name="WelcomeMessage"
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" type="submit" onClick={() => onSubmit(formApi.getValue("WelcomeMessage") as string)}>
                        Save
                    </button>
                    <button className="btn btn-outline btn-primary" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </ErrorBoundary>
        </>
    )
}


